import { ReactElement } from 'react';
import { EditTextFieldModal } from './EditTextFieldModal';
import { useTranslation } from "react-i18next";

interface RequirementExemptModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (noteText: string) => void;
  initialNote?: string;
}

export const RequirementExemptModal = ({
  isOpen,
  onClose,
  onConfirm,
  initialNote = '',
}: RequirementExemptModalProps): ReactElement => {
    const { t } = useTranslation('common');
  return (
    <EditTextFieldModal
      isOpen={isOpen}
      onClose={onClose}
      onSave={onConfirm}
      title={t('common:requirementExempt')}
      fieldLabel="Add an internal note (optional)"
      fieldSubLabel="Not shared with the applicant"
      confirmLabel="Confirm exemption"
      placeholder={t('common:addNote')}
      initialValue={initialNote}
    />
  );
};
